import { BrowserModule } from "@angular/platform-browser";
import { NgModule } from "@angular/core";
import { AppRoutingModule } from "./app-routing.module";
import { AppComponent } from "./app.component";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { FormsModule } from '@angular/forms';

// import { HttpModule } from '@angular/http';
import { UtilsModule } from './utils/utils.module';
import { AppCommonModule } from './app-common/app-common.module';
import { provideNgxWebstorage, withLocalStorage, withNgxWebstorageConfig, withSessionStorage } from 'ngx-webstorage';
import { provideHttpClient, withInterceptorsFromDi } from "@angular/common/http";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatInputModule } from "@angular/material/input";
import { MatCardModule } from '@angular/material/card';
@NgModule({
    declarations: [AppComponent],
    bootstrap: [AppComponent], imports: [BrowserModule,
        AppRoutingModule,
        BrowserAnimationsModule,
        FormsModule,
        MatInputModule,
        MatFormFieldModule,
        UtilsModule,
        AppCommonModule,
        MatCardModule,
    ], providers: [
        provideNgxWebstorage(withSessionStorage(),withLocalStorage()),
        provideHttpClient(withInterceptorsFromDi())
    ]
})
export class AppModule { }
